import Condensed from "./Condensed";
import Logo from "./Logo";

const Brand = {
    Condensed,
    Logo
};

export default Brand;